export default "__VITE_ASSET__03b7a946__"